import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import Moment from "moment";
import {
  postMDData,
  postMIData,
  postRDData,
  postMDRemark,
} from "../Actions/MDNewItemAPI";
import { AddAttachment, AddSDocAttachment } from "../Actions/AttachmentAPI";
import { confirmAlert } from "react-confirm-alert";
import { getMaterialDetails } from "../Actions/MDDetailAPI";
import appService from "../Actions/appService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
//import AutoComplete from '../core-ui/AutoComplete';
import { AutoComplete } from "primereact/autocomplete";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
toast.configure();
const MIlistInput = {
  tableValue: "",
  materialName: "",
  thresholdValue: "",
  isContainAboveThreshold: false,
  mass: "",
  unit: "",
  informationOnUsage: "",
  tabletype: "Other",
  createdBy: "",
};
const EulistInput = {
  tableValue: "",
  materialName: "",
  thresholdValue: "",
  isContainAboveThreshold: false,
  mass: "",
  unit: "",
  informationOnUsage: "",
  tabletype: "Eu",
  createdBy: "",
};
const RDlistInput = {
  attachmentType: "",
  remarks: "",
  dateOfDeclaration: "",
  documentcreationorganization: "",
  attachmentName: "",
  attachmentGuid: "",
  createdby: "",
};

class MDNewItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DatePickerIsOpen: false,
      RDDatePickerIsOpen: false,
      SelecteddateofDeclaration: "",
      dateofDeclaration: "",
      RDDate: "",
      errorMessage: false,
      MICheckBox: false,
      file: "",
      fileName: "",
      EuCheckBox: false,
      declarationID: "",
      mdfile: "",
      MDInput: {
        dateofdeclaration: "",
        mdidno: "",
        companyname: "",
        divisionname: "",
        address: "",
        telephone: "",
        fax: "",
        email: "",
        sdocidno: "",
        productnumber: "",
        productname: "",
        productinfo: "",
        contactperson: "",
        productquantityamount: "",
        productmetricunit: "",
        materialquantityamount: "",
        materialmetricunit: "",
        createdBy: "",
        attachmentName: "",
        attachmentGuid: "",
      },
      MIInput: {
        table: "",
        materialname: "",
        thresholdvalue: "",
        presentabovethresholdvalue: "No",
        mass: "",
        unit: "",
        informationonwhereitisused: "",
        tabletype: "Others",
      },
      RDInput: {
        title: "",
        remarks: "",
        dateOfDeclaration: "",
        documentcreationorganization: "",
      },
      validateFields: ["companyname", "productname", "productnumber"],
      MIRenderArray: [],
      EURenderArray: [],
      MIInputArray: [], //Combined of MI and EU regulation data's
      RDRenderArray: [],
      Remark1: "",
      Remark2: "",
      Remark3: "",
      MDremarksArray: [],
      //temp array for updating tables

      MItempArray: [],
      MItempCardNo: null,
      EUtempArray: [],
      EUtempcardNo: null,
      RDtempcardNo: null,
      RDtempArray: [],

      MDNewItemAdded: false,
      MITableDropDown: [],
      MIMaterialNameDropDown: [],
      MITVDropDown: [],
      EUTableDropDown: [],
      EUMaterialNameDropDown: [],
      EUTVDropDown: [],
      GetMaterialInfo: false,
      flag: false,
      MItable: [],
      MImaterial: [],
      MIthreshold: [],
      EUtable: [],
      EUmaterial: [],
      EUthreshold: [],
    };
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleMDInputChange = this.handleMDInputChange.bind(this);
    this.SubmitMDData = this.SubmitMDData.bind(this);
    this.handleMIInputChange = this.handleMIInputChange.bind(this);
    this.handleMICheckBoxChange = this.handleMICheckBoxChange.bind(this);
    this.handleEuCheckBoxChange = this.handleEuCheckBoxChange.bind(this);
    this.handleRDInputChange = this.handleRDInputChange.bind(this);
    this.AddMIData = this.AddMIData.bind(this);
    this.AddEUData = this.AddEUData.bind(this);
    this.AddRDData = this.AddRDData.bind(this);
    this.openRDDatePicker = this.openRDDatePicker.bind(this);
    this.handleRDDateChange = this.handleRDDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleMDInputTextareaChange =
      this.handleMDInputTextareaChange.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let updatedState = {};
    const { dispatch } = nextProps;
    if (nextProps.attachmentDetail && nextProps.isAttachment) {
      if (
        prevState.file.name === nextProps.attachmentDetail.FileName &&
        prevState.file.name !== ""
      ) {
        prevState.RDRenderArray.map((obj) => {
          if (prevState.file.name === obj.attachmentType) {
            obj.attachmentGuid = nextProps.attachmentDetail.Guid;
            obj.attachmentName = nextProps.attachmentDetail.FileName;
            prevState.file = "";
          }
          return obj;
        });
      }
    }
    if (nextProps.MdAttachment) {
      prevState.MDInput.attachmentName = nextProps.MdAttachment.FileName;
      prevState.MDInput.attachmentGuid = nextProps.MdAttachment.Guid;
      prevState.mdfile = "";
    }
    if (prevState.mdfile !== "") {
      dispatch(AddSDocAttachment(prevState.mdfile));
      prevState.mdfile = "";
    }
    if (
      nextProps.declarationID !== "" &&
      prevState.declarationID !== nextProps.declarationID &&
      nextProps.declarationID !== undefined &&
      !prevState.MDNewItemAdded
    ) {
      prevState.MDNewItemAdded = true;
      prevState.declarationID = nextProps.declarationID;
      prevState.MIRenderArray.push.apply(
        prevState.MIRenderArray,
        prevState.EURenderArray
      );
      //prevState.MIRenderArray.concat(prevState.EURenderArray);
      prevState.MIRenderArray.map((obj) => {
        obj.materialDeclarationId = nextProps.declarationID;
        return obj;
      });
      prevState.RDRenderArray.map((obj) => {
        obj.materialDeclarationId = nextProps.declarationID;
        return obj;
      });
      dispatch(postMIData(prevState.MIRenderArray));
      dispatch(postRDData(prevState.RDRenderArray));
      prevState.MDremarksArray = [
        {
          remarks: prevState.Remark1,
          createdby: nextProps.userDisplayName,
          materialDeclarationId: nextProps.declarationID,
        },
        {
          remarks: prevState.Remark2,
          createdby: nextProps.userDisplayName,
          materialDeclarationId: nextProps.declarationID,
        },
        {
          remarks: prevState.Remark3,
          createdby: nextProps.userDisplayName,
          materialDeclarationId: nextProps.declarationID,
        },
      ];
      dispatch(postMDRemark(prevState.MDremarksArray));
      nextProps.history.push("/Home");
      dispatch({ type: "MDDetail" });
    }
    return updatedState;
  }
  SubmitMDData() {
    var isvalid = this.validateFields();
    this.state.MDInput.createdBy = this.props.userDisplayName;
    if (isvalid) {
      const { dispatch } = this.props;
      dispatch(postMDData(this.state.MDInput));
      toast("MD New Item Added Successfully", {
        className: css({
          background: "#eee !important",
          color: "black !important",
          fontWeight: "bold",
        }),
        closeOnClick: false,
        autoClose: 2000,
        closeButton: false,
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
      });
    }
  }
  validateFields() {
    let count = 0;
    this.state.validateFields.map((obj) => {
      if (!this.state.MDInput[obj]) {
        this.state[obj] = true;
        count++;
      } else this.state.obj = false;
    });
    if (count) {
      this.setState({});
      return false;
    } else return true;
  }
  AddMIData() {
    this.state.MItempArray.createdBy = this.props.userDisplayName;
    var joined = this.state.MIRenderArray;
    joined.push({ ...this.state.MItempArray });
    let params = { ...MIlistInput };
    this.setState({
      MIRenderArray: joined,
      MItempArray: params,
      MICheckBox: false,
      flag: true,
    });
    this.props.dispatch(getMaterialDetails("other", "", "", ""));
  }
  AddEUData() {
    this.state.EUtempArray.createdBy = this.props.userDisplayName;
    var joined = this.state.EURenderArray;
    joined.push({ ...this.state.EUtempArray });
    let params = { ...EulistInput };
    this.setState({
      EURenderArray: joined,
      EUtempArray: params,
      EuCheckBox: false,
    });
    this.props.dispatch(getMaterialDetails("EU", "", "", ""));
  }
  AddRDData() {
    const { dispatch } = this.props;
    var joined = this.state.RDRenderArray;
    joined.push({ ...this.state.RDtempArray });
    dispatch(AddAttachment(this.state.file));
    let params = { ...RDlistInput };
    this.setState({ RDRenderArray: joined, RDtempArray: params });
  }
  UpdateEUData(index) {
    this.state.EURenderArray[index] = { ...this.state.EUtempArray };
    this.setState({
      EuCheckBox: false,
      EUtempArray: EulistInput,
      EUtempcardNo: 0,
    });
  }
  updateRDData(index) {
    this.state.RDRenderArray[index] = { ...this.state.RDtempArray };
    this.setState({
      RDtempArray: RDlistInput,
      RDtempcardNo: 0,
    });
  }
  DeleteEUData(index) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.EURenderArray.splice(index, 1);
            let params = { ...EulistInput };
            this.setState({
              EUtempArray: params,
            });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  DeleteMIData(index) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.MIRenderArray.splice(index, 1);
            let params = { ...MIlistInput };
            this.setState({
              MItempArray: params,
            });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  DeleteRDData(index) {
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.RDRenderArray.splice(index, 1);
            let params = { ...RDlistInput };
            this.setState({
              RDtempArray: params,
            });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  handleDateChange(date) {
    this.setState(
      {
        SelecteddateofDeclaration: date,
        dateofDeclaration: Moment(new Date(Date.parse(date))).format(
          "YYYY-MM-DD"
        ),
      },
      () => {
        this.state.MDInput.dateofdeclaration = this.state.dateofDeclaration;
        this.setState({ DatePickerIsOpen: false });
      }
    );
  }
  handleRDDateChange(date) {
    this.state.RDtempArray.dateOfDeclaration = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedRDDate: date,
      RDDatePickerIsOpen: false,
    });
  }
  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
    });
  }
  openRDDatePicker() {
    this.setState({
      RDDatePickerIsOpen: !this.state.RDDatePickerIsOpen,
    });
  }
  handleBlur() {
    this.setState({
      RDDatePickerIsOpen: false,
      DatePickerIsOpen: false,
    });
  }
  handleMDInputTextareaChange(e) {
    let name = e.target.name;
    this.setState({ [name]: e.target.value });
  }
  handleMDInputChange(e) {
    let nodeName = e.target.name;
    if (
      nodeName === "productquantityamount" ||
      nodeName === "materialquantityamount"
    ) {
      this.state.MDInput[nodeName] = parseInt(e.target.value);
    } else if (nodeName === "sdocidno") {
      this.state.MDInput[nodeName] = e.target.files[0].name;
      this.state.mdfile = e.target.files[0];
      this.setState({});
    } else {
      this.state.MDInput[nodeName] = e.target.value;
    }
  }

  handleMIInputChange(e) {
    let nodeName = e.target.name;
    const { dispatch } = this.props;
    this.state.MItempArray[nodeName] = e.target.value;

    this.setState({
      DatePickerIsOpen: false,
    });
    if (nodeName === "tableValue") {
      appService
        .getMaterialDetail("other", this.state.MItempArray.tableValue, "", "")
        .then((response) => {
          if (response.data[0]) {
            this.setState({
              MImaterial: response.data[0].materialname,
            });
          }
        });
      this.state.MItempArray.materialName = "";
      this.state.MItempArray.thresholdValue = "";
    } else if (nodeName === "materialName") {
      appService
        .getMaterialDetail(
          "other",
          this.state.MItempArray.tableValue,
          "",
          this.state.MItempArray.materialName
        )
        .then((response) => {
          if (response.data[0]) {
            this.setState({
              MIthreshold: response.data[0].thresholdvalue,
            });
          }
        });
    }
  }
  handleEuInputChange(e) {
    let nodeName = e.target.name;
    const { dispatch } = this.props;
    this.state.EUtempArray[nodeName] = e.target.value;

    this.setState({
      DatePickerIsOpen: false,
    });
    if (nodeName === "tableValue") {
      appService
        .getMaterialDetail("Eu", this.state.EUtempArray.tableValue, "", "")
        .then((response) => {
          if (response.data[0]) {
            this.setState({
              EUmaterial: response.data[0].materialname,
            });
          }
        });
      this.state.EUtempArray.materialName = "";
      this.state.EUtempArray.thresholdValue = "";
    } else if (nodeName === "materialName") {
      appService
        .getMaterialDetail(
          "Eu",
          this.state.EUtempArray.tableValue,
          "",
          this.state.EUtempArray.materialName
        )
        .then((response) => {
          if (response.data[0]) {
            this.setState({
              EUthreshold: response.data[0].thresholdvalue,
            });
          }
        });
    }
  }
  handleRDInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName !== "attachmentType")
      this.state.RDtempArray[nodeName] = e.target.value;
    else {
      this.state.RDtempArray[nodeName] = e.target.files[0].name;
      this.state.file = e.target.files[0];
      this.state.fileName = e.target.files[0].name;
    }
    this.setState({});
  }
  ClearInput() {
    this.state.RDtempArray.documentcreationorganization = "";
    this.setState({ file: "", mdfile: "" });
    this.state.MDInput.sdocidno = "";
  }
  editMICard = (item, tableName) => {
    const { ShowMISidePan, ShowEURegSidePan } = this.props;
    if (tableName == "Other") {
      this.state.MItempArray = { ...this.state.MIRenderArray[item] };
      this.state.MItempCardNo = item + 1;
      this.setState({
        MICheckBox: this.state.MItempArray.isContainAboveThreshold,
        flag: true,
      });
      if (!ShowMISidePan)
        this.props.dispatch({ type: "ShowMISidePan", data: true });
      appService.getMaterialDetail("other", "", "", "").then((response) => {
        if (response.data[0]) {
          this.setState({
            MItable: response.data[0].tablevalue,
            MImaterial: response.data[0].materialname,
            MIthreshold: response.data[0].thresholdvalue,
            GetMaterialInfo: true,
          });
        }
      });
    } else {
      this.state.EUtempArray = { ...this.state.EURenderArray[item] };
      this.state.EUtempcardNo = item + 1;
      this.setState({
        EuCheckBox: this.state.EUtempArray.isContainAboveThreshold,
        flag: true,
      });
      if (!ShowEURegSidePan)
        this.props.dispatch({ type: "ShowEURegSidePan", data: true });
      appService.getMaterialDetail("Eu", "", "", "").then((response) => {
        if (response.data[0]) {
          this.setState({
            EUtable: response.data[0].tablevalue,
            EUmaterial: response.data[0].materialname,
            EUthreshold: response.data[0].thresholdvalue,
            GetMaterialInfo: true,
          });
        }
      });
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 300;
  };
  editRDCard = (item) => {
    const { ShowRDSidePan } = this.props;
    this.state.RDtempArray = { ...this.state.RDRenderArray[item] };
    this.setState({
      RDtempcardNo: item + 1,
    });

    if (!ShowRDSidePan)
      this.props.dispatch({ type: "ShowRDSidePan", data: true });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 300;
  };
  UpdateMIData(index) {
    this.state.MIRenderArray[index] = { ...this.state.MItempArray };
    this.setState({
      MICheckBox: false,
      MItempArray: MIlistInput,
      MIInput: MIlistInput,
      MItempCardNo: 0,
      flag: true,
    });
  }
  handleMICheckBoxChange(e) {
    this.state.MItempArray["isContainAboveThreshold"] = e.target.checked;
    this.setState({
      MICheckBox: e.target.checked,
    });
  }
  handleEuCheckBoxChange(e) {
    this.state.EUtempArray["isContainAboveThreshold"] = e.target.checked;
    this.setState({
      EuCheckBox: e.target.checked,
    });
  }
  CancelMD() {
    this.props.dispatch({ type: "MDDetail" });
    this.props.history.push("/Home");
  }
  suggestMItable(event) {
    let results = this.state.MItable.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ MITableDropDown: results });
  }
  suggestMImaterial(event) {
    let results = this.state.MImaterial.filter((material) => {
      return material.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ MIMaterialNameDropDown: results });
  }
  suggestMIthreshold(event) {
    let results = this.state.MIthreshold.filter((threshold) => {
      return threshold.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ MITVDropDown: results });
  }
  suggestEUtable(event) {
    let results = this.state.EUtable.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EUTableDropDown: results });
  }
  suggestEUmaterial(event) {
    let results = this.state.EUmaterial.filter((material) => {
      return material.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EUMaterialNameDropDown: results });
  }
  suggestEUthreshold(event) {
    let results = this.state.EUthreshold.filter((threshold) => {
      return threshold.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EUTVDropDown: results });
  }
  render() {
    const { ShowMISidePan, ShowRDSidePan, ShowEURegSidePan, MInfoList } =
      this.props;
    return (
      <div className="full-height">
        <div className="row" style={{ height: "50px" }}></div>
        <div className="grey-bg  course-list-page row  p-3">
          <div
            className={
              ShowMISidePan || ShowRDSidePan || ShowEURegSidePan
                ? "col-lg-6 p-4 mobile"
                : "p-4"
            }
          >
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1E3A8A",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    MD Declaration
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <label className="form-label">Date of Declaration</label>
                  <br></br>
                  <div
                    className="input-group add-on date datepicker"
                    data-date-format="yyyy-mm-dd"
                  >
                    <input
                      type="text"
                      value={this.state.dateofDeclaration}
                      className="form-control date-picker"
                      placeholder="From Date"
                      name="dateofDeclaration"
                    ></input>
                    <DatePicker
                      selected={this.state.SelecteddateofDeclaration}
                      onChange={this.handleDateChange}
                      open={this.state.DatePickerIsOpen}
                      onClickOutside={this.handleBlur}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="form-control date-picker w-5 hide-date"
                    />
                    <div
                      className="input-group-btn calendar-icon"
                      onClick={this.openDatePicker}
                    >
                      <button className="btn btn-default">
                        <i className="fa fa-calendar mt-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">MD ID No</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="mdidno"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Company Name</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="companyname"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                  {this.state.companyname ? (
                    <p className="text-danger">Please Enter the Company Name</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Division Name</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="divisionname"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>

                <div className="col-lg-4">
                  <label className="form-label">Contact Person</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="contactperson"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Telephone Number</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="telephone"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Fax No</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="fax"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Email</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label">SDoC ID No</label>
                  <br></br>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        Browse File
                        <input
                          type="file"
                          id="files"
                          name="sdocidno"
                          onChange={(e) => this.handleMDInputChange(e)}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder=""
                      value={this.state.MDInput.sdocidno}
                    />
                    {this.state.MDInput.sdocidno ? (
                      <div class="input-group-append">
                        <i
                          class="fa fa-times input-group-text"
                          aria-hidden="true"
                          onClick={() => this.ClearInput()}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-lg-12">
                  <label className="form-label">Address</label>
                  <br></br>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="address"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></textarea>
                </div>
                <div className="col-lg-12">
                  <label className="form-label">Remark 1</label>
                  <br></br>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="Remark1"
                    onChange={(e) => this.handleMDInputTextareaChange(e)}
                  ></textarea>
                </div>
                <div className="col-lg-12">
                  <label className="form-label">Remark 2</label>
                  <br></br>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="Remark2"
                    onChange={(e) => this.handleMDInputTextareaChange(e)}
                  ></textarea>
                </div>
                <div className="col-lg-12">
                  <label className="form-label">Remark 3</label>
                  <br></br>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="Remark3"
                    onChange={(e) => this.handleMDInputTextareaChange(e)}
                  ></textarea>
                </div>
              </div>
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1E3A8A",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Product Information
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <label className="form-label">Product Name</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="productname"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                  {this.state.productname ? (
                    <p className="text-danger">Please Enter the Product Name</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4">
                  <label className="form-label">Product Number</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="productnumber"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                  {this.state.productnumber ? (
                    <p className="text-danger">
                      Please Enter the Product Number
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4">
                  <label className="form-label" name="address">
                    Deliver Amount
                  </label>
                  <br></br>
                  <div className="row">
                    <div className="col-lg-6">
                      <input
                        className="form-control"
                        type="text"
                        name="productquantityamount"
                        onChange={(e) => this.handleMDInputChange(e)}
                      ></input>
                    </div>
                    <div className="col-lg-6">
                      <select
                        className="form-control"
                        name="productmetricunit"
                        onChange={(e) => this.handleMDInputChange(e)}
                      >
                        <option value="unit" selected>
                          unit
                        </option>
                        <option value="piece">piece</option>
                        <option value="kg">kg</option>
                        <option value="m3">m3</option>
                        <option value="m2">m2</option>
                        <option value="m">m</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12">
                  <label className="form-label" name="productinfo">
                    Product Information
                  </label>
                  <br></br>
                  <textarea
                    className="form-control"
                    type="text"
                    rows="3"
                    name="productinfo"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></textarea>
                </div>
              </div>
              <div
                className=" card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1E3A8A",
                    color: "white",
                  }}
                >
                  <h5
                    className="flex card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Materials Information
                    <div onClick={() => this.MISidePane()}>
                      <AddIcon />
                    </div>
                  </h5>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-lg-6">
                  <label className="form-label">
                    This materials information shows the amount of hazardous
                    materials contained in
                  </label>
                </div>
                <div className="col-lg-3">
                  <input
                    className="form-control"
                    type="text"
                    name="materialquantityamount"
                    onChange={(e) => this.handleMDInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-3">
                  <select
                    className="form-control"
                    name="materialmetricunit"
                    onChange={(e) => this.handleMDInputChange(e)}
                  >
                    <option value="unit" selected>
                      unit
                    </option>
                    <option value="piece">piece</option>
                    <option value="kg">kg</option>
                    <option value="m3">m3</option>
                    <option value="m2">m2</option>
                    <option value="m">m</option>
                  </select>
                </div>
              </div>
              {this.state.MIRenderArray && this.state.MIRenderArray.length
                ? this.renderMICardData(this.state.MIRenderArray, "Other")
                : null}
              <div
                className=" card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1E3A8A",
                    color: "white",
                  }}
                >
                  <h5
                    className="flex card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    EU Regulation
                    <div onClick={() => this.EURegulationSidePane()}>
                      <AddIcon />
                    </div>
                  </h5>
                </div>
              </div>
              {this.state.EURenderArray && this.state.EURenderArray.length
                ? this.renderMICardData(this.state.EURenderArray, "EU Reg")
                : null}
              <div
                className=" card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1E3A8A",
                    color: "white",
                  }}
                >
                  <h5
                    className="flex card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    MD related documents
                    <div onClick={() => this.RDSidePane()}>
                      <AddIcon />
                    </div>
                  </h5>
                </div>
              </div>
              {this.state.RDRenderArray && this.state.RDRenderArray.length
                ? this.renderRDCardData(this.state.RDRenderArray)
                : null}
              <div className="col-lg-12 mt-2">
                <label className="form-label"></label>
                <br></br>
                <div
                  className="form-group search-btn-col"
                  style={{ textAlign: "end" }}
                >
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    type="submit"
                    onClick={() => this.SubmitMDData()}
                  >
                    {" "}
                    Submit{" "}
                  </button>

                  <button
                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                    type="button"
                    onClick={() => this.CancelMD()}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {ShowMISidePan ? (
            <div className="col-lg-6 p-4">
              <div className="panel-box search-filter-box mb-4">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Materials Information
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <label className="form-label">Table</label>
                    <br></br>

                    <AutoComplete
                      value={this.state.MItempArray.tableValue}
                      onChange={(e) => this.handleMIInputChange(e)}
                      suggestions={this.state.MITableDropDown}
                      completeMethod={this.suggestMItable.bind(this)}
                      name="tableValue"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Material Name</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.MItempArray.materialName}
                      onChange={(e) => this.handleMIInputChange(e)}
                      suggestions={this.state.MIMaterialNameDropDown}
                      completeMethod={this.suggestMImaterial.bind(this)}
                      name="materialName"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Threshold Value</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.MItempArray.thresholdValue}
                      onChange={(e) => this.handleMIInputChange(e)}
                      suggestions={this.state.MITVDropDown}
                      completeMethod={this.suggestMIthreshold.bind(this)}
                      name="thresholdValue"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">
                      Present Above Threshold Value
                    </label>

                    <input
                      type="checkbox"
                      checked={this.state.MICheckBox}
                      style={{ marginLeft: "7px" }}
                      onChange={(e) => this.handleMICheckBoxChange(e)}
                    ></input>
                  </div>
                </div>
                {this.state.MICheckBox ? (
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="form-label">Mass</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="mass"
                        onChange={(e) => this.handleMIInputChange(e)}
                        value={
                          this.state.MItempArray !== 0
                            ? this.state.MItempArray.mass
                            : ""
                        }
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Unit</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="unit"
                        onChange={(e) => this.handleMIInputChange(e)}
                        value={
                          this.state.MItempArray !== 0
                            ? this.state.MItempArray.unit
                            : ""
                        }
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">
                        Information on where it is used
                      </label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="informationOnUsage"
                        onChange={(e) => this.handleMIInputChange(e)}
                        value={
                          this.state.MItempArray !== 0
                            ? this.state.MItempArray.informationOnUsage
                            : ""
                        }
                      ></input>
                    </div>
                  </div>
                ) : null}
                {this.state.MItempCardNo ? (
                  <div className="col-lg-12 mt-2">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() =>
                          this.UpdateMIData(this.state.MItempCardNo - 1)
                        }
                      >
                        {" "}
                        Update{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() =>
                          this.DeleteMIData(this.state.MItempCardNo - 1)
                        }
                      >
                        {" "}
                        Delete{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-12 mt-2">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.AddMIData()}
                      >
                        {" "}
                        Add{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.CancelSidepan("MI")}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          {ShowEURegSidePan ? (
            <div className="col-lg-6 p-4">
              <div className="panel-box search-filter-box mb-4">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      EU Regulation
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <label className="form-label">EU reg Table</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.EUtempArray.tableValue}
                      onChange={(e) => this.handleEuInputChange(e)}
                      suggestions={this.state.EUTableDropDown}
                      completeMethod={this.suggestEUtable.bind(this)}
                      name="tableValue"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Material Name</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.EUtempArray.materialName}
                      onChange={(e) => this.handleEuInputChange(e)}
                      suggestions={this.state.EUMaterialNameDropDown}
                      completeMethod={this.suggestEUmaterial.bind(this)}
                      name="materialName"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Threshold Value</label>
                    <br></br>
                    <AutoComplete
                      value={this.state.EUtempArray.thresholdValue}
                      onChange={(e) => this.handleEuInputChange(e)}
                      suggestions={this.state.EUTVDropDown}
                      completeMethod={this.suggestEUthreshold.bind(this)}
                      name="thresholdValue"
                      inputStyle={{ borderColor: "#ced4da" }}
                    />
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Present</label>
                    <input
                      type="checkbox"
                      checked={this.state.EuCheckBox}
                      style={{ marginLeft: "7px" }}
                      onChange={this.handleEuCheckBoxChange}
                    ></input>
                  </div>
                </div>
                {this.state.EuCheckBox ? (
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="form-label">Mass</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="mass"
                        onChange={(e) => this.handleEuInputChange(e)}
                        value={
                          this.state.EUtempArray !== 0
                            ? this.state.EUtempArray.mass
                            : ""
                        }
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">Unit</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="unit"
                        onChange={(e) => this.handleEuInputChange(e)}
                        value={
                          this.state.EUtempArray !== 0
                            ? this.state.EUtempArray.unit
                            : ""
                        }
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label">
                        Information on where it is used
                      </label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="informationOnUsage"
                        onChange={(e) => this.handleEuInputChange(e)}
                        value={
                          this.state.EUtempArray !== 0
                            ? this.state.EUtempArray.informationOnUsage
                            : ""
                        }
                      ></input>
                    </div>
                  </div>
                ) : null}
                {this.state.EUtempcardNo ? (
                  <div className="col-lg-12 mt-2">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() =>
                          this.UpdateEUData(this.state.EUtempcardNo - 1)
                        }
                      >
                        {" "}
                        Update{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() =>
                          this.DeleteEUData(this.state.EUtempcardNo - 1)
                        }
                      >
                        {" "}
                        Delete{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-12 mt-2">
                    <label className="form-label"></label>
                    <br></br>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.AddEUData()}
                      >
                        {" "}
                        Add{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.CancelSidepan("EU")}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          {ShowRDSidePan ? (
            <div className="col-lg-6 p-4">
              <div className="panel-box search-filter-box mb-4">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1E3A8A",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      MD related documents
                    </h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <label className="form-label">
                      Document Creation Organization
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="documentcreationorganization"
                      onChange={(e) => this.handleRDInputChange(e)}
                      value={
                        this.state.RDtempArray.documentcreationorganization
                      }
                    ></input>
                  </div>
                  <div className="col-lg-12">
                    <label className="form-label">Remarks</label>
                    <br></br>
                    <textarea
                      className="form-control"
                      rows="6"
                      name="remarks"
                      onChange={(e) => this.handleRDInputChange(e)}
                      value={this.state.RDtempArray.remarks}
                    ></textarea>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Date of Preparation</label>
                    <br></br>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        name="name"
                        type="text"
                        placeholder="Enter the Date"
                        className="form-control date-picker"
                        data-date-format="yyyy-mm-dd"
                        value={this.state.RDtempArray.dateOfDeclaration}
                      />
                      <DatePicker
                        selected={this.state.SelectedRDDate}
                        onChange={this.handleRDDateChange}
                        open={this.state.RDDatePickerIsOpen}
                        onClickOutside={this.handleBlur}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div className="input-group-btn calendar-icon">
                        <button
                          className="btn btn-default"
                          onClick={this.openRDDatePicker}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Title</label>
                    <br></br>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          Browse File
                          <input
                            type="file"
                            id="files"
                            name="attachmentType"
                            onChange={(e) => this.handleRDInputChange(e)}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        value={this.state.RDtempArray.attachmentType}
                      />
                      {this.state.RDtempArray.attachmentType ? (
                        <div class="input-group-append">
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {this.state.RDtempcardNo ? (
                    <div className="col-lg-12 mt-2">
                      <label className="form-label"></label>
                      <br></br>
                      <div
                        className="form-group search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() =>
                            this.updateRDData(this.state.RDtempcardNo - 1)
                          }
                        >
                          {" "}
                          update{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() =>
                            this.DeleteRDData(this.state.RDtempcardNo - 1)
                          }
                        >
                          {" "}
                          Delete{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-12 mt-2">
                      <label className="form-label"></label>
                      <br></br>
                      <div
                        className="form-group search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.AddRDData()}
                        >
                          {" "}
                          Add{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.CancelSidepan("RD")}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
  renderRDCardData = (data) => {
    return data && data.length
      ? data.map((item, index) => {
          return (
            <div
              className="card MM-card-content"
              style={{ backgroundColor: "#f0f0f0" }}
              onClick={() => this.editRDCard(index)}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-6 mb-2">
                      <span>
                        <strong>Title:</strong>
                        <span className="italicFont ">
                          {item.attachmentName}&nbsp;&nbsp;
                          <i
                            className="fa fa-paperclip fa-lg"
                            style={{ width: 20 }}
                          ></i>
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-6 mb-2">
                      <span>
                        <strong>Remarks: </strong>
                        <span className="italicFont ">{item.remarks}</span>
                      </span>
                    </div>
                    <div className="col-sm-6">
                      <span>
                        <strong>Date of Preparation: </strong>
                        <span className="italicFont ">
                          {item.dateOfDeclaration}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-6">
                      <span>
                        <strong>Document Creation: </strong>
                        <span className="italicFont ">
                          {item.documentcreationorganization}{" "}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : null;
  };
  renderMICardData = (data, tableName) => {
    return data && data.length
      ? data.map((elament, index) => {
          return (
            <div
              className="card MM-card-content"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
              onClick={() => this.editMICard(index, tableName)}
            >
              {!elament.isContainAboveThreshold ? (
                <div className="arrow-right-green"></div>
              ) : (
                <div className="arrow-right-red"></div>
              )}
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-6 mb-2">
                      <span>
                        <strong>Table: </strong>
                        <span className="italicFont ">
                          {elament.tableValue}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-6 mb-2">
                      <span>
                        <strong>Material Name: </strong>
                        <span className="italicFont ">
                          {" "}
                          {elament.materialName}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-6 mb-2">
                      <span>
                        <strong>Threshold Value: </strong>
                        <span className="italicFont ">
                          {" "}
                          {elament.thresholdValue}
                        </span>
                      </span>
                    </div>
                  </div>
                  {elament.isContainAboveThreshold ? (
                    <div className="row">
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>Mass: </strong>
                          <span className="italicFont "> {elament.mass}</span>
                        </span>
                      </div>
                      <div className="col-sm-6">
                        <span>
                          <strong>Unit: </strong>
                          <span className="italicFont ">{elament.unit} </span>
                        </span>
                      </div>
                      <div className="col-sm-6">
                        <span>
                          <strong>Information on where it is Used: </strong>
                          <span className="italicFont ">
                            {elament.informationOnUsage}{" "}
                          </span>
                        </span>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })
      : null;
  };
  CancelSidepan = (type) => {
    if (type === "MI") {
      this.props.dispatch({ type: "ShowMISidePan", data: false });
    } else if (type === "EU") {
      this.props.dispatch({ type: "ShowEURegSidePan", data: false });
    } else if (type === "RD") {
      this.props.dispatch({ type: "ShowRDSidePan", data: false });
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 1000;
  };
  MISidePane = () => {
    let params = { ...MIlistInput };
    this.setState({
      MItempArray: params,
    });
    this.state.MItempCardNo = 0;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 300;
    this.props.dispatch({ type: "ShowMISidePan", data: true });
    appService.getMaterialDetail("other", "", "", "").then((response) => {
      if (response.data[0]) {
        this.setState({
          MItable: response.data[0].tablevalue,
          GetMaterialInfo: true,
        });
      }
    });
  };
  RDSidePane = () => {
    let params = { ...RDlistInput };
    this.setState({
      RDtempArray: params,
    });
    this.state.RDtempcardNo = 0;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 300;
    this.props.dispatch({ type: "ShowRDSidePan", data: true });
  };
  EURegulationSidePane = () => {
    let params = { ...EulistInput };
    this.setState({
      EUtempArray: params,
    });
    this.state.EUtempcardNo = 0;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 300;
    this.props.dispatch({ type: "ShowEURegSidePan", data: true });
    // this.props.dispatch(getMaterialDetails("EU", "", "", ""));
    appService.getMaterialDetail("EU", "", "", "").then((response) => {
      if (response.data[0]) {
        this.setState({
          EUtable: response.data[0].tablevalue,
          GetMaterialInfo: true,
        });
      }
    });
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
    ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
    ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
    declarationID: state.SidePanReducer.declarationID,
    attachmentDetail: state.SidePanReducer.attachmentDetail,
    isAttachment: state.SidePanReducer.isAttachment,
    MInfoList: state.SidePanReducer.MInfoList,
    userDisplayName: state.SidePanReducer.userDisplayName,
    MdAttachment: state.SidePanReducer.MdAttachment,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MDNewItem)
);
